import type { HTMLAttributes } from "react";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface AssistantTranscriptMarkerDividerProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  text: string;
  compact?: boolean;
  embedded?: boolean;
  running?: boolean;
  tone?: "default" | "destructive";
  testId?: string;
  labelTestId?: string;
}

export function AssistantTranscriptMarkerDivider({
  text,
  compact = false,
  embedded = false,
  running = false,
  tone = "default",
  testId,
  labelTestId,
  className,
  ...rootProps
}: AssistantTranscriptMarkerDividerProps) {
  return (
    <div
      {...rootProps}
      data-testid={testId}
      className={cn("w-full", embedded || compact ? "px-0" : "px-8", className)}
    >
      <div className={cn("flex items-center gap-3", embedded ? "py-1" : "py-3")}>
        <div className="h-px flex-1 bg-border" />
        <div
          data-testid={labelTestId}
          className={cn(
            "flex max-w-full items-center gap-2 px-1 text-xs leading-5",
            tone === "destructive" ? "text-destructive" : "text-muted-foreground"
          )}
        >
          {running ? <Spinner aria-hidden="true" className="size-3" /> : null}
          <span className="truncate">{text}</span>
        </div>
        <div className="h-px flex-1 bg-border" />
      </div>
    </div>
  );
}
